interface CheckBoxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  marginLeft?: number;
}

const CheckBox = (props: CheckBoxProps) => {
  const { label, checked, onChange, disabled } = props;
  return (
    <div className="mx-[10px] flex">
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={() => onChange()}
      />{" "}
      <div
        className="cursor-pointer font-['Open_Sans'] text-[16px] font-semibold"
        style={{ marginLeft: props.marginLeft || 5 }}
        onClick={() => onChange()}
      >
        {label}
      </div>
    </div>
  );
};

export default CheckBox;
